import styled from "styled-components";

export const Label = styled.div`
  color: ${(props) => props.color1};
`;
export const Label2 = styled.div`
  color: ${(props) => props.color2};
`;
